export const namespaced = true
const getDefaultState = () => {
    return {
        contractRegistration: [],
        selectedContractRegistration: null,
        count: 0,
    }
}
export const state = getDefaultState()

export const mutations = {
    SET_SELECTED_CONTRACT_REGISTRATION(state, data) {
        state.selectedContractRegistration = data
    },

    INCREASE_COUNT(state) {
        state.count++
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    }
}

export const actions = {

    setSelectedContractRegistration({commit}, data) {
        commit('SET_SELECTED_CONTRACT_REGISTRATION', data)
    },

    increaseCount({commit}) {
        commit('INCREASE_COUNT')
    },

    resetState({commit}) {
        commit('RESET_STATE')
    },
}


export const getters = {
}